import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MomentModule } from "angular2-moment";
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from "ng-pick-datetime";
import { OwlMomentDateTimeModule } from "ng-pick-datetime-moment";

import { GlobalAlertComponent } from "./components/scripts/globalalert.component";
import { GlobalAlertService } from "./services/globalalert.service";

import { SharedModule } from "../shared/shared.module";

import { ScheduleService } from "../shared/services/schedule.service";
import { GlobalAlertDeleteModalComponent } from "./components/scripts/globalAlertDeleteModal.component";
import { GlobalAlertScheduledComponent } from "./components/scripts/scheduled.component";
import { GlobalAlertScheduledCreateEditComponent } from "./components/scripts/scheduledCreateEdit.component";
import { EditorialToolsRoutingModule } from "./editorialtools-routing.module";
import {TagInputModule} from 'ngx-chips-4x';

export const MY_MOMENT_FORMATS = {
  parseInput: "l LT",
  fullPickerInput: "l LT",
  datePickerInput: "LL",
  timePickerInput: "LT",
  monthYearLabel: "MMM YYYY",
  dateA11yLabel: "LL",
  monthYearA11yLabel: "MMMM YYYY",
};

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        EditorialToolsRoutingModule,
        MomentModule,
        SharedModule,
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        TagInputModule,
    ],
  declarations: [
    GlobalAlertComponent,
    GlobalAlertScheduledComponent,
    GlobalAlertScheduledCreateEditComponent,
    GlobalAlertDeleteModalComponent,
  ],
  providers: [
    GlobalAlertService,
    ScheduleService,
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
  ],
  entryComponents: [GlobalAlertDeleteModalComponent],
})
export class EditorialToolsModule {}



// WEBPACK FOOTER //
// ./src/app/editorialtools/editorialtools.module.ts